declare var require: any;

import '../styles/site.scss';
import * as bootstrap from 'bootstrap';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

/// <reference path="./extensions/global.d.ts" />
import { } from './Extensions/global';
import './Extensions/string.extensions';
import './Extensions/array.extensions';
import './Extensions/date.extensions';

import * as ko from 'knockout';

import * as tinymce from 'tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/code';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/table';
import 'tinymce/plugins/wordcount';

import * as moment from 'moment';
require('datatables.net-bs5');

require("jquery-ui/ui/widgets/sortable");

export { }
declare global {
    interface Window {
        jQuery: string;
        $: string;

        logError(message): void;

        postUrl(url): void;
        postUrl(url, callback): void;
        setupSortable(): void;
        setupWysiwyg(): void;
        appendPartialHandler(url): string;
        appendFormDefaultButton(form): void;
        export(url, model): void;

        partial: Partial;
        treeView: TreeView;
    }
}

window.jQuery = $;
window.$ = $;

window.onload = function () {
    $('.loader').addClass('noShow');
}

window.appendFormDefaultButton = function (form) {
    // This copies the button marked as default and puts it at the top of the form off screen -
    // so that its the first button hit when user hits enter
    form.prepend(form.find('button.default').clone().css({
        position: 'absolute',
        left: '-999px',
        top: '-999px',
        height: 0,
        width: 0
    }));
}

window.appendPartialHandler = function (url) {
    //let newUrl = new URL(url);
    let newUrl = url.split('?');
    let params = new URLSearchParams(newUrl[1]);;

    //Add a second par parameter.
    params.append('isPartial', 'true');
    return newUrl[0] + "?" + params.toString();
}

window.onerror = function (msg, url, line, col, error) {

    $('.loader').addClass('noShow');
    // Note that col & error are new to the HTML 5 spec and may not be 
    // supported in every browser.  It worked for me in Chrome.
    let extra = !col ? '' : '\r\n column: ' + col;
    extra += !error ? '' : '\r\n error: ' + error;

    // You can view the information in an alert to see things working like this:
    let message = "Error: " + msg + "\r\n url: " + url + "\r\n line: " + line + extra;

    console.log(message);
    window.logError(message);

    let suppressErrorAlert = true;
    // If you return true, then error alerts (like in older versions of 
    // Internet Explorer) will be suppressed.
    return suppressErrorAlert;
}

window.logError = function (message) {
    let url = window.location.href;
    let form = $('#__AjaxAntiForgeryForm');
    let token = $('input[name="__RequestVerificationToken"]', form).val();

    $.ajax({
        type: 'POST',
        url: '/api/log',
        contentType: 'application/json',
        data: JSON.stringify({ logLevel: 4, message: message, url: url, __RequestVerificationToken: token }),
        success: function (response) {
        },
        error: function (jqXHR, textStatus, errorThrown) {
            //handle and after set
            jqXHR.handledLocally = true
        },
        async: false
    });
}

window.postUrl = function (url, callback = undefined) {

    let form = $('#__AjaxAntiForgeryForm');
    let token = $('input[name="__RequestVerificationToken"]', form).val();

    $.post(url, { __RequestVerificationToken: token }).done(function (response) {
        if (callback) {
            callback(response);
        }
        else if (response.redirect) {
            location = response.redirect;
        }
        else if (response.reload) {
            location.reload();
        }
    });
}

window.setupSortable = function () {
    $('#sort-list').sortable({
        stop: function () {
            let inputs = $("input[name^='Model['][name$='].SortOrder']");
            inputs.each(function (idx) {
                let sortOrder = idx + 1;
                $(this).val(sortOrder);
                $(this).parent().next().html(sortOrder);
            });
        }
    });
}

window.setupWysiwyg = function () {
    tinymce.remove();

    tinymce.init({
        selector: '.wysiwyg',
        menubar: false,
        forced_root_block: '',
        valid_elements: "div,p,span[style],br,b,i,strong,em,a[href|target=_blank],ul,ol,li,pre,blockquote",
        target_list: [
            { title: 'New page', value: '_blank' }
        ],
        default_link_target: "_blank",
        toolbar: [
            "styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | code"
        ],
        plugins: 'paste link autoresize table wordcount lists code',
        content_css: false,
        skin: false,
        content_style: "body { font-family: DIN Next LT Pro; font-size: 14px;}",
        setup: function (editor) {
            editor.on('keyUp', function () {
                editor.save(); // updates this instance's textarea
                $(editor.getElement()).trigger('change'); // for knockout to detect change
            });
            editor.on('blur', function () {
                editor.save(); // updates this instance's textarea
                $(editor.getElement()).trigger('change'); // for knockout to detect change
            });
        },
    });

    $.validator.setDefaults({
        ignore: ':hidden:not(.wysiwyg), .wysiwyg:disabled:hidden'
    });
}

window.export = function (url, model) {
    let form = $('#__AjaxAntiForgeryForm');
    let token = $('input[name="__RequestVerificationToken"]', form).val();

    $.post({
        url: url,
        xhrFields: {
            responseType: 'blob'
        },
        data: { SearchCriteria: model, __RequestVerificationToken: token },
        success: function (result, status, xhr) {
            let url = window.URL.createObjectURL(result)
            let fileName = "Export";
            let disposition = xhr.getResponseHeader('Content-Disposition');
            if (disposition && disposition.indexOf('attachment') !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, '');
                }
            }

            let $a = $('<a />', {
                'href': url,
                'download': fileName,
                'text': "click"
            });
            $a.hide();
            $a = $a.appendTo("body")[0];
            $a.click();
            $a.remove();
            URL.revokeObjectURL(url);
        }
    });
};

$.validator.unobtrusive.adapters.addBool('accept');
$.validator.unobtrusive.adapters.addBool('min-date');
$.validator.unobtrusive.adapters.addBool('less-than-or-equal-today');
$.validator.unobtrusive.adapters.addBool('date');
$.validator.unobtrusive.adapters.addBool('no-spaces');

$.validator.unobtrusive.parseDynamicContent = function (container) {
    //get forms from dynamic content
    let forms = container.find('form');

    forms.each(function () {
        let form = $(this);

        // reset the validation - as otherwise dynamic content validation doesnt work
        form.removeData("validator") /* added by the raw jquery.validate plugin */
            .removeData("unobtrusiveValidation")  /* added by the jquery unobtrusive plugin*/
            .off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");

        //form.unbind();
        form.validate().destroy();

        //use the normal unobstrusive.parse method
        $.validator.unobtrusive.parse(container);

        form.off("submit.validate"); // This is key to not firing form submit twice - tried all sorts but this was only way,
        // so now you are responsible for validating on submit manually.
    });
}

$(function () {

    $.validator.addMethod('accept', function (value, element) {
        if (!value) {
            return true;
        }
        let extension = value.replace(/^.*\./, '').toLowerCase();
        let pairs = [
            { accepts: "image/gif", extension: "gif" },
            { accepts: "image/jpg", extension: "jpg" },
            { accepts: "image/jpeg", extension: "jpeg" },
            { accepts: "image/png", extension: "png" },
            { accepts: "image/*", extension: "gif" },
            { accepts: "image/*", extension: "jpg" },
            { accepts: "image/*", extension: "jpeg" },
            { accepts: "image/*", extension: "png" },
            { accepts: "image/*", extension: "tiff" },
            { accepts: "image/*", extension: "ico" },
            { accepts: "image/*", extension: "bmp" },
            { accepts: "image/*", extension: "svg" },
            { accepts: "application/msword", extension: "doc" },
            { accepts: "application/vnd.openxmlformats-officedocument.wordprocessingm", extension: "docx" },
            { accepts: "application/vnd.ms-excel", extension: "xls" },
            { accepts: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", extension: "xlsx" },
            { accepts: "application/vnd.ms-powerpoint", extension: "ppt" },
            { accepts: "application/vnd.openxmlformats-officedocument.presentationml.presentation", extension: "pptx" },
            { accepts: "application/pdf", extension: "pdf" }
        ];
        let accepts = element.accept ? element.accept.split(",").map(x => x.trim().toLowerCase()) : [];
        let pairsToTest = pairs.filter(x => accepts.any(a => a === x.accepts));
        let acceptsWithNoValidation = accepts.filter(x => !pairs.any(p => p.accepts === x));

        if (acceptsWithNoValidation.length > 0) {
            throw "Accept validation - unmapped types - " + acceptsWithNoValidation.join(",");
        }

        if (pairsToTest.any(x => x.extension === extension)) {
            return true;
        }
        return false;
    });

    $.validator.methods.date = function (value, element) {
        let isOptional = this.optional(element);
        if (isOptional && !value) {
            return true;
        }
        let date = moment(value, "DD/MM/YYYY", true);
        if (date.isValid()) {
            return true;
        }
        return false;
    }

    $.validator.addMethod('min-date', function (value, element) {
        let isOptional = this.optional(element);
        if (isOptional && !value) {
            return true;
        }
        let date = moment(value, "DD/MM/YYYY", true);
        if (date.isValid()) {
            let minDateValue = $(element).data("min-date");

            if (minDateValue) {
                let minDate = moment(minDateValue, "DD/MM/YYYY", true).toDate();
                return date.toDate() >= minDate;
            }
        }
        return true;
    });

    $.validator.addMethod('less-than-or-equal-today', function (value, element) {
        let isOptional = this.optional(element);
        if (isOptional && !value) {
            return true;
        }
        let date = moment(value, "DD/MM/YYYY", true);
        if (date.isValid()) {
            return date.toDate() <= moment().startOf('day').toDate();
        }
        return true;
    });

    $.validator.addMethod("date", function (value, element) {
        return !value || moment(value, "DD/MM/YYYY", true).isValid();
    });

    $.validator.addMethod("no-spaces", function (value, element) {
        return !value || value.trim().indexOf(" ") <= -1;
    });

    document.addEventListener('focusin', (e) => {
        if ((<any>e.target).closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
            e.stopImmediatePropagation();
        }
    });

    window.setupWysiwyg();
    window.setupSortable();

    $('body').on('change', '.custom-file-input', function () {
        let fileName = $(this).val().split("\\").pop();
        $(this).next('.custom-file-label').html(fileName);
    });

    $('form').each(function () {
        window.appendFormDefaultButton($(this));
    });

    $.each($('.datepicker'), function () {
        let minDate = $(this).data('min-date');

        $(this).datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: minDate ? new Date(minDate) : undefined,
            onClose: function () {
                $(this).valid();
            }
        });
    });
    $(".datepicker + .input-group-append").click(function () {
        $(this).prev().datepicker('show')
    });

    $.datepicker.setDefaults($.datepicker.regional['en-GB']);

    $("form").submit(function (e) {
        let form = $(this);
        let action = form.attr('action');
        let hash = window.location.hash;

        if (!action) {
            action = window.location.href;
        }

        if (action) {
            if (action.indexOf('#') != -1) {
                action = action.split('#')[0];
            }

            if (hash) {
                action = action + hash;
                form.attr('action', action);
            }
        }
    });

    $('body').on('change', 'input[type=text]', function () {
        $(this).val($(this).val().trim());
    });
    $('body').on('change', 'textarea', function () {
        $(this).val($(this).val().trim());
    });


    $('body').on('show.bs.modal', '.modal:not(#edit-resource):not(.inline-container)', function (e) {
        $(e.target).appendTo('#modal-container');
    });

    $('body').on('click', 'a', function (e) {
        let url = $(this).attr('href');
        let isModal = $(this).hasClass('isModal');
        let isOffcanvas = $(this).hasClass('isOffcanvas');
        let isContainer = $(this).hasClass('isContainer');
        let isPartial = $(this).hasClass('isPartial');
        let isPost = $(this).hasClass('isPost');
        let isTreeViewAction = $(this).hasClass('treeView-action');
        let isToggle = $(this).data('toggle') || $(this).attr('rel') == "popover";
        let isHash = $(this).attr('href') === "#";

        if (isModal) {
            e.preventDefault();
            window.partial.openModalPopup(url);
        }
        else if (isPost) {
            e.preventDefault();
            window.postUrl(url);
        }
        else if (isOffcanvas) {
            e.preventDefault();
            window.partial.openOffCanvas(url, undefined, undefined);
        }
        else if (isContainer) {
            e.preventDefault();
            window.partial.openContainer(url, undefined, undefined);
        }
        else if (isPartial) {
            e.preventDefault();
            history.pushState(null, null, url);
            window.partial.openContainer(url + "?isPartial=true", undefined, undefined);
        }
        else if (isTreeViewAction) {
            e.preventDefault();
            let treeView = $("#treeView").jstree(true);
            let selectedId = $(this).data('treeview-id');
            treeView.deselect_node(treeView.get_selected());
            treeView.select_node(selectedId);
        }
        else if (isToggle || isHash) {
            e.preventDefault();
        }
    });


    $('#confirm-navigate .btn-ok').click((e) => {
        let href = $(e.currentTarget).attr("href");
        if (href) {
            if (href.startsWith('#')) {
                window.location.href = window.location.href.split('#')[0] + href;
                window.location.reload();
            }
            else {
                window.location.href = href;
            }
        }
    });

    var url = document.location.toString();
    if (url.match('#')) {
        $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
    }
    $('.nav-tabs a').on('shown.bs.tab', function (e) {
        if (history.pushState) {
            history.pushState(null, null, location.origin + location.pathname + (location.search ? location.search : "") + e.target.hash);
        }
        else {
            location.hash = e.target.hash;
        }
    });


    $('body').on('click', 'a#sort-list-alphabetical', function (e) {
        e.preventDefault();

        var $tbody = $('#sort-list');

        $tbody.find('tr').sort(function (a, b) {
            var aName = $(a).data('name').toLowerCase().trim(); // target order attribute
            var bName = $(b).data('name').toLowerCase().trim(); // target order attribute
            // if a < b return 1
            return aName > bName ? 1
                // else if a > b return -1
                : aName < bName ? -1
                    // else they are equal - return 0    
                    : 0;
        }).appendTo($tbody);


        let inputs = $("input[name^='Model['][name$='].SortOrder']");
        inputs.each(function (idx) {
            let sortOrder = idx + 1;
            $(this).val(sortOrder);
            $(this).parent().next().html(sortOrder);
        });
    });

    $('body').on('change', 'nav .pagination .page-size:not(.content-container .page-size)', function (e) {
        let path = $(this).data('url');
        if (path.indexOf('https://') == -1) {
            path = window.location.origin + path;
        }

        let url = new URL(path);
        let params = new URLSearchParams(url.search);
        let pageSize = $(e.currentTarget).val();
        params.append("pageSize", pageSize.toString());

        let newUrl = url.toString() + "?" + params;

        window.location.href = newUrl;
    });

    $.ajaxPrefilter(function (options) {
        options.global = true;
    });

    $.ajaxSetup({ headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache', 'Expires': '0' } });

    $(document)
        .ajaxError(function (event, jqxhr, settings, thrownError) {
            if (thrownError === "abort") {
                return;
            }

            if (!jqxhr.handledLocally) {
                window.logError(thrownError + ' | ' + jqxhr.responseText);
            }

            $('.loader').addClass('noShow');
            let href = $("base").attr('href') + "/Error/500";
            if (!jqxhr.handledLocally && $("base").attr('href').indexOf("-dev.bcs.org") < 0) {
                location.href = href;
            }
        })
        .ajaxSend(function (event, request, settings) {
            if (settings.url.toLowerCase().indexOf("spinner=false") == -1 && settings.url.indexOf(".js") == -1) {
                $('.loader').removeClass('noShow');
            }
        })
        .ajaxStop(function () {
            $('.loader').addClass('noShow');
        });

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl,
        {
            sanitize: false,
            html: true
        }));

    bootstrap.Tooltip.Default.allowList.table = [];
    bootstrap.Tooltip.Default.allowList.thead = [];
    bootstrap.Tooltip.Default.allowList.tbody = [];
    bootstrap.Tooltip.Default.allowList.tr = [];
    bootstrap.Tooltip.Default.allowList.td = [];

    $('#hamburger').bind('click', function () {
        processSidebar();
    });

    let sidebarKey = 'sidebar';
    let sidebarSmall = 'sidebarSmall';

    showSidebar();

    function processSidebar() {
        let type = window.localStorage.getItem(sidebarKey);

        if (!type) {
            window.localStorage.setItem(sidebarKey, sidebarSmall);
        }
        else {
            window.localStorage.removeItem(sidebarKey);
        }

        showSidebar();
    }

    function showSidebar() {
        let sidebar = $('#' + sidebarKey);
        let doc = $('html');
        let classtr = window.localStorage.getItem(sidebarKey);

        if (classtr) {
            doc.addClass(sidebarSmall);
        }
        else {
            doc.removeClass(sidebarSmall);
        }

        //sidebar.show();
    }

    $('.sidebar a').bind('click', function (e) {
        //e.preventDefault();
        let type = window.localStorage.getItem(sidebarKey);
        let position = $('.sidebar').css('position');

        if (position == 'absolute' && !type) {
            window.localStorage.setItem(sidebarKey, sidebarSmall);
        }

    });
});

// --- Knockout binding handlers ---

ko.bindingHandlers.initValue = {
    init: function (element, valueAccessor) {
        let value = valueAccessor();
        if (!ko.isWriteableObservable(value)) {
            throw new Error('Knockout "initValue" binding expects an observable.');
        }
        value(element.value);
    }
};

ko.bindingHandlers.initChecked = {
    init: function (element, valueAccessor, allBindings, data, context) {
        if (!ko.isWriteableObservable(valueAccessor())) {
            throw new Error('Knockout "initChecked" binding expects an observable.');
        }

        valueAccessor()(element.checked);
    }
};

ko.bindingHandlers.initNumber = {
    init: function (element, valueAccessor) {
        let value = !!element.value ? JSON.parse(element.value) : undefined;
        if (!ko.isWriteableObservable(valueAccessor())) {
            throw new Error('Knockout "initValue" binding expects an observable.');
        }
        valueAccessor()(value);
    }
};

ko.bindingHandlers.initBoolean = {
    init: function (element, valueAccessor) {
        let value = !!element.value ? JSON.parse(element.value) : undefined;
        if (!ko.isWriteableObservable(valueAccessor())) {
            throw new Error('Knockout "initValue" binding expects an observable.');
        }
        valueAccessor()(value);
    }
};

ko.bindingHandlers.booleanValue = {
    init: function (element, valueAccessor, allBindingsAccessor, data, context) {
        var observable = valueAccessor(),
            interceptor = ko.computed({
                read: function () {
                    return observable().toString();
                },
                write: function (newValue) {
                    observable(newValue === "true");
                }
            });

        ko.applyBindingsToNode(element, { value: interceptor }, context);
    }
};

ko.bindingHandlers.valueWithInit = {
    init: function (element, valueAccessor, allBindings, data, context) {
        ko.applyBindingsToNode(element, { initValue: valueAccessor() }, context);
        ko.applyBindingsToNode(element, { value: valueAccessor() }, context);
    }
};

ko.bindingHandlers.textInputWithInit = {
    init: function (element, valueAccessor, allBindings, data, context) {
        ko.applyBindingsToNode(element, { initValue: valueAccessor() }, context);
        ko.applyBindingsToNode(element, { textInput: valueAccessor() }, context);
    }
};

ko.bindingHandlers.checkedWithInit = {
    init: function (element, valueAccessor, allBindings, data, context) {
        ko.applyBindingsToNode(element, { initChecked: valueAccessor() }, context);
        ko.applyBindingsToNode(element, { checked: valueAccessor() }, context);
    }
};

ko.bindingHandlers.numberWithInit = {
    init: function (element, valueAccessor, allBindings, data, context) {
        ko.applyBindingsToNode(element, { initNumber: valueAccessor() }, context);
        ko.applyBindingsToNode(element, { value: valueAccessor() }, context);
    }
};

ko.bindingHandlers.booleanWithInit = {
    init: function (element, valueAccessor, allBindings, data, context) {
        ko.applyBindingsToNode(element, { initBoolean: valueAccessor() }, context);
        ko.applyBindingsToNode(element, { booleanValue: valueAccessor() }, context);
    }
};


ko.bindingHandlers.selectedDataAttribute = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var dataAttribute = ko.utils.unwrapObservable(valueAccessor().bind);
        var viewModelProperty = valueAccessor().to;
        var dataAttributeValue = $(element).find(':selected').attr(dataAttribute);
        viewModel[viewModelProperty](dataAttributeValue);
        $(element).change(function () {
            var dataAttribute = ko.utils.unwrapObservable(valueAccessor().bind);
            var viewModelProperty = valueAccessor().to;
            var dataAttributeValue = $(element).find(':selected').attr(dataAttribute);
            viewModel[viewModelProperty](dataAttributeValue);
        });
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var dataAttribute = ko.utils.unwrapObservable(valueAccessor().bind);
        var viewModelProperty = valueAccessor().to;
        var value = viewModel[viewModelProperty]();

        $("option", element).filter(function (option) {
            if (!value) {
                return false;
            }
            return $(option).attr(dataAttribute) === value;
        }).prop("selected", "selected");
    }
}

ko.bindingHandlers.panelSplitter = {
    init: function (element, valueAccessor) {
        // Query the element
        const resizer = element.getElementsByClassName('drag-handle')[0];
        const leftSide = resizer.previousElementSibling as HTMLElement;
        const rightSide = resizer.nextElementSibling as HTMLElement;

        // The current position of mouse
        let x = 0;
        let y = 0;

        // Width of left side
        let leftWidth = 0;

        // Handle the mousedown event
        // that's triggered when user drags the resizer
        const mouseDownHandler = function (e) {
            // Get the current mouse position
            x = e.clientX;
            y = e.clientY;
            leftWidth = leftSide.getBoundingClientRect().width;

            // Attach the listeners to `document`
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };

        const mouseUpHandler = function () {
            resizer.style.removeProperty('cursor');
            document.body.style.removeProperty('cursor');

            leftSide.style.removeProperty('user-select');
            leftSide.style.removeProperty('pointer-events');

            rightSide.style.removeProperty('user-select');
            rightSide.style.removeProperty('pointer-events');

            // Remove the handlers of `mousemove` and `mouseup`
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };

        const mouseMoveHandler = function (e) {
            resizer.style.cursor = 'col-resize';
            document.body.style.cursor = 'col-resize';
            leftSide.style.userSelect = 'none';
            leftSide.style.pointerEvents = 'none';

            rightSide.style.userSelect = 'none';
            rightSide.style.pointerEvents = 'none';
            // How far the mouse has been moved
            const dx = e.clientX - x;
            const dy = e.clientY - y;

            const parentNode = resizer.parentNode as Element;

            const newLeftWidth = ((leftWidth + dx) * 100) / parentNode.getBoundingClientRect().width;
            if (newLeftWidth <= 50) {
                leftSide.style.width = `${newLeftWidth}%`;
                rightSide.style.width = `${(100 - newLeftWidth - 10)}%`;
            }
        };

        // Attach the handler
        resizer.addEventListener('mousedown', mouseDownHandler);

    }
}



let koObsFn: any = ko.observable.fn;
koObsFn.ignoreSilentUpdateSubscribe = function (callback, thisValue, event) {
    var self = this;
    this.subscribe(function (newValue) {
        if (!self.silent)
            callback(newValue);
    }, thisValue, event);
    return this;
};
koObsFn.silentUpdate = function (newValue) {
    this.silent = true;
    var result = this(newValue);
    this.silent = undefined;
    return result;
};

ko.bindingHandlers.enterKey = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        var callback = valueAccessor();

        $(element).keypress(function (event) {
            var keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                event.preventDefault();
                callback.call(viewModel);
                return false;
            }
            return true;
        });
    }
};


$.fn.DataTable.render.date = function (data, type, row) {
    if (type == "sort") {
        return data ? data.format('YYYYMMDD') : "";
    }
    else {
        return data ? data.format('DD MMM YYYY') : "";
    }
}

$.fn.DataTable.ext.pager.numbers_length = 9;
$.fn.DataTable.ext.pager.custom = function (page, pages) {
    let numbers: any = [];
    var buttons = $.fn.DataTable.ext.pager.numbers_length;
    var half = Math.floor(buttons / 2);

    var _range = function (len, start) {
        var end;

        if (typeof start === "undefined") {
            start = 0;
            end = len;

        } else {
            end = start;
            start = len;
        }

        var out = [];
        for (var i = start; i < end; i++) { out.push(i); }

        return out;
    };


    if (pages <= buttons) {
        numbers = _range(0, pages);

    } else if (page <= half) {
        numbers = _range(0, buttons);

    } else if (page >= pages - 1 - half) {
        numbers = _range(pages - buttons, pages);

    } else {
        numbers = _range(page - half, page + half + 1);
    }

    numbers.DT_el = 'span';
    return ['first', 'previous', numbers, 'next', 'last'];
};

class Partial {

    openModalPopup(url, container = undefined, callback = undefined) {
        if (!container) {
            container = "modal-container";
        }
        this.openContainer(url, container, callback);
    }

    openOffCanvas(url, container = undefined, callback = undefined) {
        if (!container) {
            container = "offcanvas-container";
        }
        this.openContainer(url, container, callback);
    }

    openContainer(url, container = undefined, callback = undefined) {
        let self = this;
        if (url) {
            $.get(url).done(function (data) {
                if (!container) {
                    container = "content-container";
                }

                if (data.redirect) {
                    location = data.redirect;
                }
                else if (data.reload) {
                    location.reload();
                }

                self.openContainerFromData($("#" + container), data, callback);
            });
        }
    }

    openFilter(url, model, callback) {
        let self = this;
        let container = "modal-container";
        if (url) {
            let form = $('#__AjaxAntiForgeryForm');
            let token = $('input[name="__RequestVerificationToken"]', form).val();

            $.post(url, { input: model, __RequestVerificationToken: token }).done(function (data) {
                self.openContainerFromData($("#" + container), data, callback);
            });
        }
    }

    openContainerFromData(container, data, callback = undefined) {
        if (!container) {
            throw "Container not found";
        }

        if (container.has('.offcanvas.show').length > 0) {
            container.find('script').remove();
            container.find('.offcanvas.show .offcanvas-wrapper').remove();
            container.find('.offcanvas.show').append($(data).find('.offcanvas-wrapper'));
            container.append($(data).filter('script'));
            this.parseContainer(container, callback);
        }
        else {
            container.html(data); // put html in the container
            this.parseContainer(container, callback);
        }
    }

    parseContainer(container, callback = undefined) {
        if (!container) {
            throw "Container not found";
        }

        $.validator.unobtrusive.parseDynamicContent(container);

        $.each($('.datepicker'), function () {
            let minDate = $(this).data('min-date');
            $(this).datepicker({
                dateFormat: 'dd/mm/yy',
                minDate: minDate ? new Date(minDate) : undefined,
                onClose: function () {
                    $(this).valid();
                }
            });
        });
        $(".datepicker + .input-group-append").click(function () {
            $(this).prev().datepicker('show')
        });

        $.datepicker.setDefaults($.datepicker.regional['en-GB']);

        if (container.find(' > .offcanvas').length > 0) {
            let offcanvas = container.find(' > .offcanvas');
            offcanvas.offcanvas('show');
        }

        if (container.find(' > .modal').length > 0) {
            let modal = container.find(' > .modal');
            modal.modal({ backdrop: 'static', cache: false });
            modal.modal('show');
        }

        window.setupWysiwyg();
        window.setupSortable();
        
        let form = container
            .find('form')
            .filter(function (i, form) {
                return !form.dataset || !form.dataset.bind || form.dataset.bind.indexOf('submit:') < 0;
            });

        let intercept = form.length > 0;
        if (form.length > 1) {
            form = form[0];
        }

        if (intercept) {
            let validator = null;

            form.on('submit', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                e.stopPropagation();

                $(this).find(':input[type=submit]').prop('disabled', true);

                if (!validator) {
                    validator = form.validate({
                        errorPlacement: function (error, element) { },
                        submitHandler: function (form) { }
                    });
                }

                // Trigger the form validation - must do this, before!! i trigger validation on fields i have not touched - dont ask me why
                validator.checkForm();

                //Setup interval which will evaluate validation 
                //(this approach because of remote validation)
                let validationIntervalId = setInterval(() => {
                    if (validator.pendingRequest === 0) {

                        // Trigger showing this error
                        let inputs = form.find(":input:not(input[type=button],input[type=button],input[type=submit],button,:hidden), .wysiwyg:input:hidden");

                        if (inputs.length > 0) {
                            inputs.valid();
                        }

                        clearInterval(validationIntervalId);

                        if (validator.checkForm()) {

                            let url = form.attr('action');

                            if (e && e.originalEvent && e.originalEvent.submitter && $(e.originalEvent.submitter).attr('formAction')) {
                                url = $(e.originalEvent.submitter).attr('formAction');
                            }

                            $.post(url, form.serialize())
                                .done(function (response) {
                                    if (callback) {
                                        callback(response);
                                    }
                                    else if (response.hash) {
                                        location.hash = response.hash;
                                        location.reload();
                                    }
                                    else if (response.redirect) {
                                        location = response.redirect;
                                    }
                                    else {
                                        location.reload();
                                    }
                                });
                        }
                        else {
                            $(this).find(':input[type=submit]').prop('disabled', false);
                        }
                    }
                }, 50);
            });
        }
    }
}
window.partial = new Partial();

class TreeView {

    filterTreeView(treeView, searchText, filters = []) {
        let noDataText = treeView.element.data('nodata');
        this.filterDataSource(treeView.dataSource, noDataText, searchText, filters);
    }

    filterDataSource(dataSource, noDataText, searchText, filters = []) {
        let data: any[] = Array.from(dataSource.data());
        let noData: any = data.find(x => x.id == -1);

        if (noData) {
            dataSource.remove(noData);
        }

        this.filterDataSourceRecursive(dataSource, searchText, filters);

        // Refresh data
        data = Array.from(dataSource.data());

        let hasAnyVisible = data.any(x => !x.hidden);
        
        if (!hasAnyVisible) {
            dataSource.insert({ id: -1, text: noDataText });
        }

        if (data.length === 1) {
            let item = data[0];
            item.expanded = true;

            // Re-apply the filter on the children.
            dataSource.filter({ field: "hidden", operator: "neq", value: true });
            this.initialiseIndeterminates(data);
        }
    }

    filterDataSourceRecursive(dataSource, searchText, filters = [], parentVisible = undefined) {
        let hasVisibleChildren = false;
        let data = dataSource.data();

        if (searchText === undefined) {
            searchText = "";
        }
            
        searchText = searchText.toLowerCase();

        let hasSearchCriteria = !!searchText || filters.any(x => x.ids.any());

        for (let i = 0; i < data.length; i++) {
            let item = data[i];

            if (item.id == -1) {
                //console.log(item.id, item.text, item.hidden);
                continue;
            }

            if (!hasSearchCriteria) { // query is empty
                let anyVisibleChildren = item.hasChildren ? this.filterDataSourceRecursive(item.children, searchText, filters, true) : false; 
                item.selected = false;
                item.hidden = false;
                item.expanded = false;
            }
            else {
                let text = item.searchText ? item.searchText.toLowerCase() : item.text.toLowerCase();

                let matches = [];
                for (let f = 0; f < filters.length; f++) {
                    let filter = filters[f];
                    let id = item.htmlAttributes && item.htmlAttributes[filter.attribute] ? item.htmlAttributes[filter.attribute] : undefined;
                    let match = (!filter.ids.any() || filter.ids.any(fid => fid === id));

                    matches.push(match);
                }

                let isMatch = text.indexOf(searchText) >= 0 && // item text matches query
                    (!matches || matches.every(x => x === true));

                let itemVisible = parentVisible === true || // parent already matches
                    isMatch // is a match;

                let anyVisibleChildren = item.hasChildren ? this.filterDataSourceRecursive(item.children, searchText, filters, itemVisible) : false; // pass true if parent matches

                hasVisibleChildren = hasVisibleChildren || anyVisibleChildren || isMatch;
                                
                item.selected = isMatch;
                item.hidden = !itemVisible && !anyVisibleChildren;
                item.expanded = anyVisibleChildren;

                if (item.id == -1) {
                    console.log(item.id, item.text, item.hidden);
                }
            }
        }

        if (data) {
            // Re-apply the filter on the children.
            dataSource.filter({ field: "hidden", operator: "neq", value: true });
            this.initialiseIndeterminates(data);
        }

        return hasVisibleChildren;
    }
    
    initialiseIndeterminates(nodes): void {
        for (let i = 0; i < nodes.length; i++) {
            let dataNode = nodes[i];
            let hasCheckedChildren = $("li[data-uid='" + dataNode.uid + "']").find("input:checked").length > 0;
            let checkbox = $('#_' + dataNode.uid);
            let isIndeterminate = dataNode.checked && !dataNode.hidden ? false : (hasCheckedChildren);
            
            checkbox.prop({
                indeterminate: isIndeterminate
            });

            if (hasCheckedChildren && dataNode.hasChildren) {
                this.initialiseIndeterminates(dataNode.children.view());
            }
        }
    }
    
    setupIndeterminate(dataNode): void {   
        let hasCheckedChildren = dataNode.hasChildren && dataNode.items.filter(x => x.get("checked")).any();
        let hasIndeterminateChildren = dataNode.hasChildren && dataNode.items.filter(x => !x.hidden && $('#_' + x.uid).is(':indeterminate')).any();
        
        let checkbox = $('#_' + dataNode.uid);
        let isIndeterminate = dataNode.checked ? false : (hasCheckedChildren || hasIndeterminateChildren);

        checkbox.prop({
            indeterminate: isIndeterminate
        });

        if (dataNode.parentNode()) {
            this.setupIndeterminate(dataNode.parentNode());
        }
    }

    checkUncheckAllNodes(nodes, checked, checkChildren) {
        if (typeof checkChildren === "undefined") { checkChildren = true; }

        for (let i = 0; i < nodes.length; i++) {
            let dataNode = nodes[i];
            let checkbox = $('#_' + dataNode.uid);

            dataNode.set("checked", checked);
            checkbox.prop({ indeterminate: false });

            if (checkChildren && dataNode.hasChildren) {
                this.checkUncheckAllNodes(dataNode.children.view(), checked, true);
            }
        }
    }

    getCheckedNodes(dataSource): any {
        let data: any[] = Array.from(dataSource.data());
        let node;
        let checkedNodes = [];

        for (let i = 0; i < data.length; i++) {
            node = data[i];
            if (node.checked) {
                checkedNodes.push({ text: node.text, id: node.id });
            }
            if (node.hasChildren) {
                let childNodes = this.getCheckedNodes(node.children);
                checkedNodes = checkedNodes.concat(childNodes);
            }
        }
        return checkedNodes;
    }
}

window.treeView = new TreeView();